// components/Container.js
import React from "react";

const Container = ({ children }) => {
  return <div className="mx-auto max-w-screen-xl">{children}</div>;
};

export default Container;
